"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTransfer = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@nfid/core");
const core_2 = require("@nfid/core");
const default_provider_1 = require("./default-provider");
function requestTransfer(params, config) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const provider = (config === null || config === void 0 ? void 0 : config.provider) || default_provider_1.defaultProvider;
        const windowFeatures = (config === null || config === void 0 ? void 0 : config.windowFeatures) || core_1.defaultWindowFeatures;
        return new Promise((resolve) => {
            const handler = handleRequestTransferFactory(resolve, provider, params);
            window.addEventListener('message', handler);
            window.onbeforeunload = () => {
                window.removeEventListener('message', handler);
            };
            (0, core_1.createWindow)(provider.toString(), () => {
                window.removeEventListener('message', handler);
                resolve({
                    status: 'ERROR',
                    message: 'Terminated by user',
                });
            }, windowFeatures);
        });
    });
}
exports.requestTransfer = requestTransfer;
const handleRequestTransferFactory = (resolve, provider, params) => function handler(event) {
    if (!(0, core_2.validateEventOrigin)(event, provider.origin))
        return;
    if (event.data.kind === 'Ready') {
        (0, core_1.postMessageToProvider)({
            kind: 'RequestTransfer',
            params,
        });
    }
    if (event.data.kind === 'RequestTransferResponse') {
        window.removeEventListener('message', handler);
        resolve(event.data.result);
        (0, core_1.done)();
    }
};
